<template>
  <v-container fluid style="font-family: 'Montserrat', sans-serif">
    <v-row>
      <v-col cols="12" class="pa-0">
        <PrivacyPortalHeader />
      </v-col>
      <v-col cols="12" class="pa-0">
        <PrivacyPolicy />
      </v-col>
      <v-col cols="12" class="pa-0">
        <PrivacyPortalFooter />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PrivacyPortalHeader from "@/components/PrivacyPortal/Header.vue";
import PrivacyPortalFooter from "@/components/PrivacyPortal/Footer.vue";
import PrivacyPolicy from "@/components/PrivacyPortal/PrivacyPolicy.vue";

export default {
  name: "PrivacyPolicyExternal",
  components: {
    PrivacyPortalHeader: PrivacyPortalHeader,
    PrivacyPortalFooter: PrivacyPortalFooter,
    PrivacyPolicy: PrivacyPolicy,
  },
};
</script>
